import React from 'react';

import { RoleGuard } from '@components/Guards';

import { RoleName } from '@constants/role_name';

import Tasks from '@views/Records/Tasks/Main';

export default function TasksPage() {
  return (
    <RoleGuard roles={[RoleName.Curator]}>
      <Tasks />
    </RoleGuard>
  );
}
